
import { tw } from '@core/tailwind'

import translations from './ProductCard.translations'

const MAX_COLORS = 4

export default {
  props: {
    /** @type { { value: string, name: string }[] } */
    colors: { type: Array, default: () => [] },
    /** @type { 'xs' | 'sm' } */
    size: { type: String, default: 'xs' },
    /** @type { number } */
    maxColors: { type: Number, default: MAX_COLORS },
  },
  computed: {
    translations: () => translations,
    classes: () => ({
      xs: {
        radius: tw`w-3 h-3`,
        gap: tw`gap-x-[0.2rem]`,
        text: tw`body-3-light`,
      },
      sm: { radius: tw`w-4 h-4`, gap: tw`gap-x-2`, text: tw`body-2-bold` },
    }),
    distinctColors() {
      return this.colors.slice(0, this.maxColors)
    },
    clusteredColors() {
      return this.colors.slice(this.maxColors)
    },
  },
}
